import type { ProcessMessageKey } from './process.en'

/** Processing-site phone strings (Hindi), spread into hi.ts. The type forces every key. */
export const processHi: Record<ProcessMessageKey, string> = {
  'process.devSeed': 'प्रोसेसिंग साइट का डेमो डेटा लोड करें',
  'process.home.section': 'प्रोसेसिंग',
  'process.saveFailed': 'फ़ोन में सेव नहीं हुआ',
  'process.remove': 'हटाएँ',
  'process.lot': 'लॉट',
  'process.farmer': 'किसान',
  'process.moisture': 'नमी (%)',
  'process.bagsIn': '{n} {n:बोरी|बोरियाँ} अंदर',
  'process.sacksN': '{n} {n:बोरी|बोरियाँ}',
  'process.typeAgain': 'वज़न दोबारा लिखें',
  'process.typeAgainHint': 'यह वज़न एक बोरी के आम वज़न से अलग है, इसलिए दो बार लिखें।',
  'process.typeAgainMismatch': 'दोनों वज़न मेल नहीं खाते',

  'process.cache.update': 'साइट सूची अपडेट करें',
  'process.cache.updated': 'साइट सूची अपडेट हो गई',
  'process.cache.failed': 'साइट सूची अपडेट नहीं हुई',
  'process.cache.needsNetwork': 'अपडेट के लिए नेटवर्क चाहिए',
  'process.cache.age': 'साइट सूची {when} की',
  'process.cache.stale': 'साइट सूची एक दिन से पुरानी है',
  'process.cache.expired': 'साइट सूची बहुत पुरानी है — काम से पहले अपडेट करें',
  'process.cache.missingTitle': 'इस फ़ोन में साइट सूची नहीं है',
  'process.cache.missingBody':
    'नेटवर्क में एक बार साइट सूची डाउनलोड करें: फिर मशीन, रन और बोरियाँ बिना नेटवर्क चलेंगी।',

  'process.badge.notSynced': 'अभी भेजा नहीं',
  'process.badge.heldAtOffice': 'ऑफिस में रोका',
  'process.badge.syncProblem': 'सिंक में दिक्कत',
  'process.stream.MAIN': 'ब्रांड',
  'process.stream.CONV': 'साधारण',
  'process.status.OPEN': 'खुला',
  'process.status.RUNNING': 'चालू',
  'process.status.CLOSED': 'बंद',
  'process.status.BALANCED': 'हिसाब ठीक',
  'process.status.EXCEPTION': 'रोका गया',
  'process.status.CANCELLED': 'रद्द',

  'process.runs.title': 'मशीन रन',
  'process.runs.hint': 'रन खोलें, सफ़ाई, अंदर-बाहर का वज़न, बंद करें',
  'process.runs.open': 'खुले रन · {n}',
  'process.runs.noneOpen': 'इस साइट पर कोई रन खुला नहीं है।',
  'process.runs.recent': 'हाल में बंद',
  'process.runs.sampleDue': '{n} ब्रांड {n:बैच|बैच} का क्यूसी नमूना लेना है।',
  'process.runs.flagged': '{n} {n:रन|रन} जाँच के लिए रोके गए हैं।',

  'process.open.title': 'रन खोलें',
  'process.open.machine': 'मशीन लेबल',
  'process.open.step': 'काम',
  'process.open.scanLot': 'लॉट की एक बोरी स्कैन करें',
  'process.open.addLot': 'उसी किसान का दूसरा लॉट जोड़ें',
  'process.open.lots': 'इस रन के लॉट',
  'process.open.check': 'खोलने से पहले देखें',
  'process.open.runType': 'रन का प्रकार',
  'process.open.planned': 'योजना के किलो',
  'process.open.plannedOfMin': '{kg} (कम से कम {min})',
  'process.open.previous': 'इस मशीन पर पिछला रन',
  'process.open.previousUnknown': 'पता नहीं (साझा मशीन)',
  'process.open.flush': 'फ़्लश',
  'process.open.flushNeeded': 'ज़रूरी: कम से कम {kg}',
  'process.open.allergen': 'एलर्जन सफ़ाई',
  'process.open.allergenNeeded': 'ज़रूरी: फसल बदली या पता नहीं',
  'process.open.notNeeded': 'ज़रूरी नहीं',
  'process.open.belowMinTitle': 'लॉट इस मशीन के न्यूनतम से छोटा है',
  'process.open.belowMinBody':
    'ब्रांड रन के लिए इस मशीन को कम से कम {min} चाहिए। उसी किसान, फसल और सीज़न के दूसरे लॉट की बोरी स्कैन करें, या रुकें और ऑफिस को फ़ोन करें।',
  'process.open.offlineNote': 'बिना नेटवर्क खोला: फ़्लश और पूरी एलर्जन सफ़ाई ज़रूरी है।',
  'process.open.done': 'रन {code} खुल गया',

  'process.cancel.button': 'रन रद्द करें',
  'process.cancel.hint': 'सिर्फ़ तब तक जब कोई बोरी अंदर न गई हो।',
  'process.cancel.confirm': 'यह रन रद्द करें',
  'process.cancel.reason.WRONG_MACHINE': 'गलत मशीन स्कैन हुई',
  'process.cancel.reason.WRONG_LOT': 'गलत लॉट स्कैन हुआ',
  'process.cancel.reason.OTHER': 'दूसरा कारण',
  'process.cancel.done': 'रन रद्द हो गया',

  'process.run.title': 'रन',
  'process.run.missing': 'यह रन फ़ोन में नहीं है',
  'process.run.missingBody': 'नेटवर्क में साइट सूची अपडेट करें।',
  'process.run.startedAt': '{time} शुरू',
  'process.run.syncError': 'इस रन का कुछ भेजा नहीं जा सका। सिंक में देखें।',
  'process.run.sampleNow':
    'बोरियाँ मशीन एरिया से जाने से पहले इस रन के ब्रांड बैच का क्यूसी नमूना लें।',
  'process.tab.cleanout': 'सफ़ाई',
  'process.tab.in': 'अंदर',
  'process.tab.run': 'चालू',
  'process.tab.out': 'बाहर',

  'process.cleanout.title': 'सफ़ाई और फ़्लश',
  'process.cleanout.intro':
    'मशीन पूरी खाली करें। अंदर बचा कुछ भी फ़्लश बोरी में जाए, ब्रांड बोरी में कभी नहीं।',
  'process.cleanout.allergenTitle': 'पूरी एलर्जन सफ़ाई',
  'process.cleanout.allergenWhyCrop':
    'इस मशीन पर पिछला रन {crop} का था। पूरी मशीन ब्रश करें, हवा से साफ़ करें और चूट पोंछें।',
  'process.cleanout.allergenWhyUnknown':
    'इस मशीन पर पिछली फसल पता नहीं। पूरी मशीन ब्रश करें, हवा से साफ़ करें और चूट पोंछें।',
  'process.cleanout.allergenPhoto': 'साफ़ पूरी मशीन की फ़ोटो',
  'process.cleanout.allergenDone': 'एलर्जन सफ़ाई हो गई',
  'process.cleanout.photosTitle': 'मशीन खाली',
  'process.cleanout.empty': 'मशीन खाली',
  'process.cleanout.emptyHint': 'पहले सारी फ़ोटो लें (और ज़रूरत हो तो एलर्जन सफ़ाई)।',
  'process.cleanout.confirm': 'सफ़ाई पक्की',
  'process.cleanout.confirmed': 'सफ़ाई पक्की हुई',
  'process.cleanout.saved': 'सफ़ाई सेव हुई',
  'process.flush.title': 'फ़्लश बोरी',
  'process.flush.afterCleanout':
    'पहली बोरी डालने के बाद जो भी निकले, फ़्लश बोरी में लें जब तक कम से कम {kg} न हो जाए। यह हमेशा साधारण माल है: लाल टाई।',
  'process.flush.notNeeded': 'इस रन में फ़्लश ज़रूरी नहीं।',
  'process.flush.more': '{kg} और फ़्लश चाहिए',
  'process.flush.met': 'फ़्लश पूरा: {kg}',

  'process.weighIn.title': 'अंदर का वज़न',
  'process.weighIn.locked': 'अंदर का वज़न बंद है',
  'process.weighIn.lockedBody': 'पहले सफ़ाई पक्की करें; उससे पहले कोई बोरी अंदर नहीं जाती।',
  'process.weighIn.scan': 'हॉपर पर बोरी स्कैन करें',
  'process.weighIn.bag': 'बोरी',
  'process.weighIn.issueWeight': 'जारी करते समय का वज़न',
  'process.weighIn.notSeen':
    'इस फ़ोन ने इस बोरी का जारी होना नहीं देखा। काँटे पर रखकर वज़न लिखें; ऑफिस बाद में जाँचेगा।',
  'process.weighIn.weight': 'वज़न (किलो)',
  'process.weighIn.weightHint': 'काँटा जो दिखाए, बोरी समेत',
  'process.weighIn.bagIn': 'बोरी अंदर',
  'process.weighIn.tinHint': 'बोरी डालें, टैग काटें और नष्ट-डिब्बे में डालें।',
  'process.weighIn.saved': '{tag} अंदर',
  'process.weighIn.bagsIn': 'अंदर बोरियाँ',
  'process.weighIn.kgIn': 'अंदर किलो',
  'process.weighIn.waiting': 'जारी, अभी अंदर नहीं · {n}',
  'process.weighIn.inList': 'अंदर गई बोरियाँ',
  'process.weighIn.weighedHere': 'यहाँ तौली',

  'process.running.title': 'रन चालू है',
  'process.running.started': 'शुरू',
  'process.running.notStarted': 'अभी कोई बोरी अंदर नहीं',
  'process.running.inSoFar': 'अंदर बोरियाँ / किलो',
  'process.running.settings': 'सेटिंग',
  'process.running.settingsHint': 'रन बंद करते समय भेजी जाएगी।',
  'process.running.sweepHint':
    'आख़िरी माल निकलने पर मशीन खाली करें और झाड़न कचरे की बोरी में डालें।',
  'process.running.stopped': 'मशीन रुकी',
  'process.running.stoppedAt': 'मशीन {time} पर रुकी',
  'process.running.undoStop': 'वापस लें',
  'process.mixing.button': 'मिलावट हुई',
  'process.mixing.hint':
    'पूरा रन तुरंत साधारण हो जाएगा, पहले टैग हुई बोरियाँ भी। आगे हर बोरी पर लाल टाई।',
  'process.mixing.confirm': 'मिलावट दर्ज करें',
  'process.mixing.saved': 'मिलावट दर्ज: यह रन अब साधारण है',
  'process.mixing.reportedTitle': 'मिलावट दर्ज',
  'process.mixing.reportedBody': 'यह रन साधारण माल है। हर बोरी पर लाल टाई बाँधें।',
  'process.mixing.reason.RAIN': 'आँगन में बारिश',
  'process.mixing.reason.SPILL': 'माल गिरा',
  'process.mixing.reason.OTHER_FARMER': 'दूसरे किसान का माल',
  'process.mixing.reason.MACHINE_NOT_EMPTY': 'मशीन खाली नहीं थी',
  'process.mixing.reason.OTHER': 'दूसरा',

  'process.weighOut.title': 'बाहर का वज़न',
  'process.weighOut.output': 'क्या निकला',
  'process.weighOut.newSack': 'नई बोरी',
  'process.weighOut.tag': 'बोरी का टैग',
  'process.weighOut.sackType': 'बोरी का प्रकार',
  'process.weighOut.weight': 'वज़न (किलो)',
  'process.weighOut.weightHint': 'काँटा जो दिखाए; बोरी ({tare}) घटाई जाएगी',
  'process.weighOut.net': 'बोरी घटाकर: {kg}',
  'process.weighOut.save': 'बोरी सहेजें',
  'process.weighOut.saved': '{name}: {kg} सेव',
  'process.weighOut.byOutput': 'हर चीज़ की बोरियाँ',
  'process.weighOut.none': 'कुछ नहीं निकला',
  'process.weighOut.zero': 'कुछ नहीं',
  'process.weighOut.void': 'यह बोरी रद्द करें',
  'process.weighOut.voided': 'बोरी रद्द हुई',
  'process.void.WRONG_OUTPUT': 'गलत चीज़ दबाई',
  'process.void.WRONG_WEIGHT': 'गलत वज़न लिखा',
  'process.void.TAG_PROBLEM': 'टैग में दिक्कत',
  'process.void.OTHER': 'दूसरा',
  'process.output.FLUSH': 'फ़्लश',
  'process.output.LEFTOVER': 'बचा माल',
  'process.output.SPILLAGE': 'गिरा माल',
  'process.tie.red': 'लाल टाई',
  'process.tie.redShort': 'साधारण',
  'process.tie.none': 'टाई नहीं',
  'process.tie.redBanner': 'साधारण माल: इस बोरी पर लाल टाई बाँधें',

  'process.close.button': 'रन बंद करें',
  'process.close.notYet': 'रन बंद करने के लिए चाहिए',
  'process.close.done': 'रन बंद हुआ। नतीजा सिंक के बाद दिखेगा।',
  'process.close.gap.NO_CLEANOUT': 'सफ़ाई पक्की',
  'process.close.gap.NO_INPUT': 'कम से कम एक बोरी अंदर',
  'process.close.gap.FLUSH_SHORT': '{kg} और फ़्लश',
  'process.close.gap.OUTPUT_MISSING': '{name}: बोरी, या कुछ नहीं',
  'process.close.gap.BAGS_NOT_IN': '{n} जारी {n:बोरी|बोरियाँ} अंदर स्कैन, या गोदाम वापस रखे',
  'process.close.gap.NOT_STOPPED': 'मशीन रुकी',

  'process.balance.provisional': 'जोड़ · सिंक तक कच्चा',
  'process.balance.synced': 'जोड़ · ऑफिस ने जाँचा',
  'process.balance.provisionalHint': 'इस फ़ोन पर निकाला। सिंक के बाद ऑफिस की जाँच इसकी जगह लेगी।',
  'process.balance.pass': 'हिसाब ठीक',
  'process.balance.held': 'रोका जाएगा',
  'process.balance.in': 'अंदर किलो',
  'process.balance.flush': 'फ़्लश',
  'process.balance.product': 'माल',
  'process.balance.byproduct': 'उप-उत्पाद',
  'process.balance.waste': 'कचरा',
  'process.balance.leftOver': 'बचा अंतर (सीमा {limit})',
  'process.balance.yield': 'माल की उपज',
  'process.balance.yieldRange': 'माल की उपज ({min} – {max})',
  'process.balance.kind.RESIDUAL': 'नुकसान सीमा से ज़्यादा',
  'process.balance.kind.YIELD': 'उपज आम दायरे से बाहर',
  'process.balance.kind.SURPLUS': 'अंदर से ज़्यादा बाहर',
  'process.balance.kind.EXACT_ZERO': 'अंतर ठीक शून्य',

  'process.closed.cancelled': 'यह रन रद्द हुआ।',
  'process.closed.waitingTitle': 'इस फ़ोन पर बंद',
  'process.closed.waitingBody': 'फ़ोन सिंक होने पर ऑफिस हिसाब जाँचेगा।',
  'process.closed.balancedTitle': 'हिसाब ठीक',
  'process.closed.balancedBody': 'बोरियाँ रखी, जारी या पैक की जा सकती हैं।',
  'process.closed.heldTitle': 'जाँच के लिए रोका',
  'process.closed.heldBody':
    'सुपरवाइज़र के समस्या बंद करने तक बोरियाँ रखी जा सकती हैं, पर जारी या पैक नहीं।',
  'process.closed.outputs': 'बोरियाँ',
  'process.closed.samples': 'क्यूसी नमूने',
  'process.problem.BALANCE_OUT_OF_BAND': 'वज़न का हिसाब नहीं मिला',
  'process.problem.RUN_MIXED': 'मिलावट',
  'process.problem.LATE_ENTRY': 'देर से दर्ज',
  'process.problem.BAG_COUNT_MISMATCH': 'बोरी कम',
  'process.problem.TAG_CONFLICT': 'टैग दो बार लगा',
  'process.problem.TAG_REUSED': 'इस्तेमाल हुआ टैग स्कैन हुआ',
  'process.problem.LABEL_MISMATCH': 'लेबल जाँच',
  'process.problem.WEIGHT_OUT_OF_RANGE': 'पाउच का वज़न कम',
  'process.problem.LAB_FAIL': 'लैब में फ़ेल',
  'process.problem.OTHER': 'समस्या',

  'process.label.title': 'मशीन लेबल',
  'process.label.hint': 'मशीन का लेबल लगाएँ और जोड़ें',
  'process.label.scan': 'मशीन लेबल',
  'process.label.machine': 'मशीन',
  'process.label.machineHint': 'इस साइट की मशीनें जिन पर अभी लेबल नहीं',
  'process.label.site': 'साइट',
  'process.label.photo': 'मशीन पर लगे लेबल की फ़ोटो',
  'process.label.bind': 'लेबल जोड़ें',
  'process.label.done': 'लेबल {code} से जुड़ा',
  'process.label.allLabelled': 'इस साइट की हर मशीन पर पहले से लेबल है।',

  'process.issue.title': 'रन को देना',
  'process.issue.hint': 'लॉट की बोरियाँ रन को दें, हर बोरी तौलें',
  'process.issue.none': 'जारी करने का कोई काम नहीं',
  'process.issue.noneBody':
    'ऑफिस हर काम तय करता है (लॉट से रन)। नए काम देखने के लिए साइट सूची अपडेट करें।',
  'process.issue.task': 'जारी करने का काम',
  'process.issue.toRun': 'रन {run} को',
  'process.issue.progress': '{m} में से {n} बोरियाँ',
  'process.issue.lots': 'लॉट',
  'process.issue.run': 'रन',
  'process.issue.bags': 'बोरियाँ',
  'process.issue.kgSoFar': 'अब तक किलो',
  'process.issue.scan': 'काँटे पर बोरी स्कैन करें',
  'process.issue.bagTag': 'बोरी का टैग',
  'process.issue.sackType': 'बोरी का प्रकार',
  'process.issue.weight': 'वज़न (किलो)',
  'process.issue.weightHint': 'काँटे पर अकेली बोरी',
  'process.issue.moisture': 'नमी (%)',
  'process.issue.moistureOnce': 'हर लॉट में एक बार, मीटर हो तो',
  'process.issue.moistureNeeded': 'सुखाने के लिए हर लॉट में एक बार ज़रूरी',
  'process.issue.moistureMissing': 'जारी पूरा से पहले हर लॉट की नमी एक बार लिखें।',
  'process.issue.save': 'बोरी सहेजें',
  'process.issue.saved': '{tag}: {kg} जारी',
  'process.issue.carryHint': 'हर बोरी मशीन एरिया में रन की बाकी बोरियों के साथ रखें।',
  'process.issue.done': 'जारी पूरा',
  'process.issue.shortConfirm':
    '{n} {n:बोरी नहीं मिली|बोरियाँ नहीं मिलीं}। उनकी अलग समस्या ऑफिस के पास रहेगी।',
  'process.issue.closed': 'जारी पूरा',
  'process.issue.otherTask': 'दूसरे काम',

  'process.qc.title': 'क्यूसी नमूना',
  'process.qc.hint': 'लैब के लिए ब्रांड बैच का नमूना सील करें',
  'process.qc.none': 'किसी बैच का नमूना बाकी नहीं',
  'process.qc.noneBody': 'सिर्फ़ पैकिंग से पहले के आख़िरी रन के ब्रांड बैच का नमूना लिया जाता है।',
  'process.qc.batch': 'बैच',
  'process.qc.sacks': 'इन बोरियों से स्कूप लें',
  'process.qc.howTo': 'हर बोरी से एक स्कूप साफ़ नमूना थैली में। मिलाएँ, निशान तक भरें और बंद करें।',
  'process.qc.seal': 'नमूना सील',
  'process.qc.sealHint': 'इस साइट की नमूना सील रेंज से',
  'process.qc.weight': 'नमूने का वज़न (ग्राम)',
  'process.qc.photo': 'सील नमूने की फ़ोटो',
  'process.qc.sealIt': 'नमूना सील करें',
  'process.qc.done': 'नमूना {seal} से सील हुआ',
  'process.qc.dispatchNote': 'भेजने के लिए सौंप दें; ऑफिस लैब और तारीख़ दर्ज करेगा।',
  'process.qc.sealed': 'सील',
  'process.qc.confirming': 'पुष्टि नमूना',
  'process.qc.confirmingHint': 'रोका बैच: नया नमूना माँगा गया',
  'process.qc.confirmingBanner':
    'यह बैच रोका गया है। लैब नतीजे की पुष्टि के लिए क्वालिटी टीम ने नया नमूना माँगा है।',

  'process.investigate.title': 'जाँच',
  'process.investigate.hint': 'रोके गए रन को ठीक करें और दोबारा जाँच भेजें',
  'process.investigate.none': 'कोई रन रोका नहीं गया',
  'process.investigate.noneBody': 'इस साइट के रोके गए रन सिंक के बाद यहाँ दिखेंगे।',
  'process.investigate.flagged': 'रोके गए रन',
  'process.investigate.ownTitle': 'अनुमति नहीं',
  'process.investigate.ownBody':
    'इस रन में मशीन आपने चलाई या साफ़ की। जिस सुपरवाइज़र ने नहीं चलाई, वही ठीक करेगा।',
  'process.investigate.run': 'रन',
  'process.investigate.machine': 'मशीन',
  'process.investigate.cause': 'कारण',
  'process.investigate.correction': 'सुधार',
  'process.investigate.tag': 'बोरी का टैग',
  'process.investigate.weight': 'सही वज़न (किलो)',
  'process.investigate.record': 'दर्ज करें',
  'process.investigate.recorded': 'सुधार · {n}',
  'process.investigate.leftNow': 'अब बचा अंतर',
  'process.investigate.recheck': 'दोबारा जाँचें',
  'process.investigate.noCorrectionHint': 'कोई सुधार न हो तो ऑफिस फ़ैसला करते समय कारण दर्ज करेगा।',
  'process.investigate.sent': 'सुधार भेजे गए। ऑफिस रन दोबारा जाँचेगा।',
  'process.correction.REWEIGH_OUTPUT': 'बोरी दोबारा तौलें',
  'process.correction.ADD_OUTPUT': 'छूटी बोरी जोड़ें',
  'process.correction.ADD_INPUT': 'बोरी बिना स्कैन अंदर गई',
  'process.correction.VOID_OUTPUT': 'बोरी रद्द करें',
  'process.cause.UNWEIGHED_SACK': 'बिना तौली बोरी',
  'process.cause.SCALE_ERROR': 'काँटे में गलती',
  'process.cause.TYPING_ERROR': 'लिखने में गलती',
  'process.cause.BAG_IN_WITHOUT_SCAN': 'बोरी बिना स्कैन अंदर',
  'process.cause.HIGH_MOISTURE': 'ज़्यादा नमी',
  'process.cause.MACHINE_FAULT': 'मशीन ख़राबी',
  'process.cause.BAND_WRONG': 'आम दायरा गलत',
  'process.cause.UNEXPLAINED_LOSS': 'बिना कारण नुकसान',
  'process.cause.MIXING': 'मिलावट',

  'process.refusal.TAG_UNKNOWN': 'यह कोड फ़ोन में नहीं',
  'process.refusal.TAG_WRONG_KIND': 'गलत तरह का टैग',
  'process.refusal.TAG_VOID': 'यह टैग रद्द हो चुका है',
  'process.refusal.TAG_USED': 'यह टैग पहले ही इस्तेमाल हो चुका है',
  'process.refusal.NOT_YOUR_ROLL': 'आपके रोल का नहीं',
  'process.refusal.NOT_A_MACHINE_LABEL': 'यह मशीन लेबल नहीं है',
  'process.refusal.MACHINE_HAS_LABEL': 'इस मशीन पर पहले से लेबल है',
  'process.refusal.MACHINE_BUSY': 'इस मशीन पर रन {code} खुला है — पहले बंद या रद्द करें',
  'process.refusal.MACHINE_OTHER_SITE': 'दूसरी साइट की मशीन',
  'process.refusal.NO_SETTINGS': 'इस फसल के लिए मशीन तैयार नहीं',
  'process.refusal.LOT_ON_HOLD': 'लॉट रोका गया है',
  'process.refusal.LOT_USED_UP': 'लॉट पहले ही इस्तेमाल हो चुका',
  'process.refusal.LOT_ELSEWHERE': 'लॉट इस साइट पर नहीं',
  'process.refusal.OTHER_FARMER': 'दूसरे किसान का लॉट',
  'process.refusal.OTHER_CROP': 'दूसरी फसल',
  'process.refusal.OTHER_STREAM': 'ब्रांड और साधारण नहीं मिलते',
  'process.refusal.NOT_ON_TASK': 'इस काम का लॉट नहीं — वापस रखें',
  'process.refusal.NOT_ISSUED': 'इस रन को जारी नहीं',
  'process.refusal.ISSUED_ELSEWHERE': 'पहले ही जारी',
  'process.refusal.DUPLICATE': 'पहले ही स्कैन हो चुका',
  'process.refusal.NOT_THIS_BATCH': 'इस बैच की बोरी नहीं',
  'process.refusal.NOT_A_SACK': 'यहाँ बोरी का टैग चाहिए',
  'process.refusal.MACHINE_NO_LABEL': 'इस मशीन पर अभी लेबल नहीं है — पहले लेबल लगाएँ',
  'process.refusal.OTHER_MACHINE_LABEL': 'यह {machine} का लेबल है — चुनी हुई मशीन का लेबल स्कैन करें',
  // V1 processing boards (features/process/v1)
  'process.v1.lang': 'hi',
  'process.v1.farmerNo': 'नं. {no}',
  'process.v1.ordinary': 'लाल टाई माल',
  'process.v1.kgUnit': 'किलो',
  'process.v1.kg': '{kg} किलो',
  'process.v1.tag': 'टैग {no}',
  'process.v1.scanned': 'स्कैन हुआ',
  'process.v1.weigh.badTag': 'टैग फटा या गलत: बदलें',
  'process.v1.weigh.sackAria': 'बोरी {name}, {kg} किलो',
  'process.v1.call.dial': 'कॉल करें',
  'process.v1.call.noNumber': 'नंबर नहीं',
  'process.v1.call.body': 'क्वालिटी वाले को {number} पर कॉल करें।',
  'process.v1.call.none': 'इस फ़ोन में क्वालिटी का नंबर नहीं। सुपरवाइज़र को बताएँ।',
  'process.v1.noPack.title': 'साइट की सूची डाउनलोड करें',
  'process.v1.noPack.body':
    'इस फ़ोन में अभी मशीनों और रन की सूची नहीं है। इंटरनेट से जोड़कर डाउनलोड करें।',
  'process.v1.noPack.download': 'डाउनलोड करें',
  'process.v1.noPack.needsNet': 'इंटरनेट नहीं है',
  'process.v1.home.title': 'आज · {date}',
  'process.v1.home.noRun': 'कोई रन खुला नहीं',
  'process.v1.home.runOpen': 'रन …{code} · {machine}',
  'process.v1.home.step1': 'रन खोलें',
  'process.v1.home.step2': 'सफ़ाई',
  'process.v1.home.step3': 'बोरी अंदर',
  'process.v1.home.step4': 'मशीन चलाएँ',
  'process.v1.home.step5': 'तौलें, बंद',
  'process.v1.home.sample': 'लैब का नमूना',
  'process.v1.home.sampleLine': 'पैकिंग वाला बैच',
  'process.v1.home.check': 'रन जाँचें',
  'process.v1.home.checkLine': '{count} रन रुके',
  'process.v1.home.open': 'रन खोलें',
  'process.v1.home.continue': 'आगे बढ़ें',
  'process.v1.home.godown': 'गोदाम',
  'process.v1.home.godownLine': 'माल लें, रखें, गिनें',
  'process.v1.pick.title': 'कौन सी मशीन?',
  'process.v1.pick.hint': '**मशीन** देखकर चुनें',
  'process.v1.pick.busy': 'रन खुला: …{code}',
  'process.v1.pick.office': 'ऑफ़िस को फ़ोन',
  'process.v1.pick.wait': 'मशीन चुनें',
  'process.v1.pick.none': 'साइट की सूची में कोई मशीन नहीं। ऑफ़िस से पूछें।',
  'process.v1.lot.title': 'लॉट की एक बोरी',
  'process.v1.lot.hint': 'कोई एक बोरी',
  'process.v1.lot.stays': 'बोरी गोदाम में रहेगी',
  'process.v1.lot.wait': 'टैग स्कैन करें',
  'process.v1.machineScan.title': 'मशीन का लेबल स्कैन करें',
  'process.v1.machineScan.hint': 'इस मशीन पर लगा लेबल',
  'process.v1.machineScan.wait': 'मशीन का लेबल स्कैन करें',
  'process.v1.machineScan.why': 'मशीन के पास जाकर लॉट से पहले उसका लेबल स्कैन करें',
  'process.v1.machineScan.noLabel': 'इस मशीन पर अभी लेबल नहीं है। प्रोसेसिंग से पहले लेबल लगाएँ।',
  'process.v1.machineScan.labelIt': 'इस मशीन पर लेबल लगाएँ',
  'process.v1.machineScan.askSupervisor': 'सुपरवाइज़र से इस मशीन पर लेबल लगवाएँ।',
  'process.v1.machineScan.scanned': 'लेबल स्कैन हुआ',
  'process.v1.check.title': 'जाँचें',
  'process.v1.check.good': 'अच्छा माल',
  'process.v1.check.red': 'लाल टाई माल',
  'process.v1.check.lot': 'लॉट …{code}',
  'process.v1.check.fullClean': 'पूरी सफ़ाई ज़रूरी: फसल बदली',
  'process.v1.check.moreLots': 'और लॉट',
  'process.v1.check.open': 'रन खोलें',
  'process.v1.cancel.menu': 'रन रद्द करें',
  'process.v1.cancel.title': 'रन रद्द करें?',
  'process.v1.cancel.line': '{count} बोरी अंदर · रन …{code}',
  'process.v1.cancel.back': 'गोदाम बोरियाँ वापस जगह पर रखेगा',
  'process.v1.cancel.yes': 'हाँ, रद्द करें',
  'process.v1.cancel.notNow': 'बोरी अंदर जा चुकी: रन रद्द नहीं होगा',
  'process.v1.clean.title': 'मशीन खाली',
  'process.v1.clean.opened': 'रन …{code} खुला',
  'process.v1.clean.full': 'पूरी सफ़ाई · फसल बदली',
  'process.v1.clean.s1': 'छलनियाँ **बाहर**, ब्रश',
  'process.v1.clean.s2': 'चूट अंदर से पोंछें',
  'process.v1.clean.s3': 'पूरी मशीन, हवा से',
  'process.v1.clean.photo': 'खाली हॉपर, ढक्कन खोलकर',
  'process.v1.clean.taken': 'ली',
  'process.v1.clean.take': 'फोटो लें',
  'process.v1.clean.again': 'दोबारा',
  'process.v1.clean.done': 'मशीन खाली',
  'process.v1.clean.wait': 'खाली मशीन की फोटो',
  'process.v1.in.title': 'बोरी अंदर',
  'process.v1.in.next': 'अगली बोरी',
  'process.v1.in.allTitle': 'सब अंदर',
  'process.v1.in.band': '{grade} · अंदर {count} बोरी',
  'process.v1.in.bandKg': '{grade} · अंदर {count} बोरी · {kg} किलो',
  'process.v1.in.thisRun': 'इसी रन की',
  'process.v1.in.lastWeight': 'पिछला वज़न',
  'process.v1.in.s1': '**हॉपर** में',
  'process.v1.in.s2': 'टैग **काटें**',
  'process.v1.in.tipped': 'डाल दी, टैग टिन में',
  'process.v1.in.saved': 'बोरी {n} अंदर · {kg} किलो',
  'process.v1.in.first': 'पहली बोरी',
  'process.v1.in.before': 'डालने से पहले',
  'process.v1.in.allIn': 'सब बोरियाँ अंदर',
  'process.v1.in.count': '{count} बोरी अंदर',
  'process.v1.in.tin': 'कटे टैग: {count} टिन में',
  'process.v1.in.wait': 'पहले एक बोरी डालें',
  'process.v1.wrong.title': 'बोरी नहीं चलेगी',
  'process.v1.wrong.tag': 'टैग {tag}: {why}',
  'process.v1.wrong.s1': 'हॉपर में **न डालें**, टैग न काटें',
  'process.v1.wrong.s2': 'गोदाम वाले को लौटाएँ',
  'process.v1.wrong.bagOf': 'बोरी का',
  'process.v1.wrong.runOf': 'रन का',
  'process.v1.wrong.ok': 'समझ आ गया',
  'process.v1.next': 'आगे',
  'process.v1.supervisor': 'सुपरवाइज़र',
  'process.v1.run.title': 'मशीन चालू',
  'process.v1.run.mixing': 'दूसरा माल मिला?',
  'process.v1.run.started': '{time} शुरू',
  'process.v1.run.tip1': 'हर माल **अपनी** बोरी में',
  'process.v1.run.tip2': '**आख़िर** में झाड़न कचरे में',
  'process.v1.run.weigh': 'बोरी तौलें',
  'process.v1.mix.title': 'दूसरा माल मिला?',
  'process.v1.mix.body': 'पूरा रन **लाल टाई**, बनी बोरियाँ भी',
  'process.v1.mix.yes': 'हाँ, मिला',
  'process.v1.mix.reported': 'दूसरा माल बताया: रन लाल टाई',
  'process.v1.out.title': 'कौन सा माल?',
  'process.v1.out.sacks': '{count} बोरी',
  'process.v1.out.none': 'कुछ नहीं निकला',
  'process.v1.out.wait': 'माल चुनें',
  'process.v1.none.title': 'किस माल से कुछ नहीं निकला?',
  'process.v1.none.zero': '0 किलो लिखा जाएगा',
  'process.v1.tag.title': 'टैग लगाएँ',
  'process.v1.tag.band': '{grade} · {name} · बोरी {n}',
  'process.v1.tag.hint': 'रोल का नया टैग',
  'process.v1.tag.fixLast': 'पिछली ठीक',
  'process.v1.tag.bad': 'टैग ख़राब',
  'process.v1.tag.done': '{name} पूरा',
  'process.v1.tag.saved': 'बोरी {n} · {kg} किलो',
  'process.v1.tag.badDone': 'टैग फेंक दिया: नया लगाएँ',
  'process.v1.weigh.title': 'वज़न लिखें',
  'process.v1.weigh.bench': 'छोटा काँटा',
  'process.v1.weigh.label': 'बोरी {n} · बारदाना समेत',
  'process.v1.weigh.labelWaste': 'बारदाना समेत',
  'process.v1.weigh.net': 'माल {kg}',
  'process.v1.weigh.saveNext': 'सेव, अगली बोरी',
  'process.v1.weigh.save': 'सेव करें',
  'process.v1.weigh.again': 'वज़न ज़्यादा या कम लगा: फिर से लिखें',
  'process.v1.weigh.notSame': 'दोनों वज़न अलग: फिर से लिखें',
  'process.v1.weigh.tooLight': 'खाली बारदाने से कम',
  'process.v1.weigh.wait': 'वज़न लिखें',
  'process.v1.fix.title': 'पिछली बोरी हटाएँ?',
  'process.v1.fix.body': 'माल या वज़न ग़लत? हटाकर फिर से तौलें।',
  'process.v1.fix.yes': 'हाँ, हटाएँ',
  'process.v1.totals.title': 'सब माल तौला?',
  'process.v1.totals.in': 'अंदर',
  'process.v1.totals.out': 'बाहर',
  'process.v1.totals.more': 'और बोरी',
  'process.v1.totals.change': '{name} बदलें',
  'process.v1.totals.close': 'रन बंद करें',
  'process.v1.totals.missing': '{name}: तौलें या कुछ नहीं',
  'process.v1.close.title': 'रन बंद करें?',
  'process.v1.close.line': '{bags} बोरी अंदर · {sacks} बोरी बाहर',
  'process.v1.close.locked': 'बंद के बाद कोई बोरी नहीं जुड़ेगी',
  'process.v1.close.yes': 'हाँ, बंद करें',
  'process.v1.closed.title': 'रन बंद',
  'process.v1.closed.place': 'बोरियाँ मशीन वाली जगह पर',
  'process.v1.closed.kg': 'अंदर {in} · बाहर {out} किलो',
  'process.v1.closed.less': '{kg} किलो कम: ऑफ़िस जाँचेगा',
  'process.v1.closed.lessOk': '{kg} किलो कम: सीमा के अंदर',
  'process.v1.closed.more': '{kg} किलो ज़्यादा निकला: ऑफ़िस जाँचेगा',
  'process.v1.closed.zero': 'एकदम बराबर: ऑफ़िस जाँचेगा',
  'process.v1.closed.sample': 'लैब का नमूना लें',
  'process.v1.closed.home': 'होम',
  'process.v1.qc.title': 'लैब का नमूना',
  'process.v1.qc.batch': '{name} · {count} बोरी',
  'process.v1.qc.batchLine': '{kg} किलो · बैच …{code} · पैकिंग',
  'process.v1.qc.notThese': 'इनका नमूना नहीं',
  'process.v1.qc.none': 'अभी किसी बैच का नमूना बाकी नहीं',
  'process.v1.qc.wait': 'बैच चुनें',
  'process.v1.scoop.title': 'हर बोरी से स्कूप',
  'process.v1.scoop.bag': '**साफ़** थैली में डालें',
  'process.v1.scoop.done': '{count} बोरी से स्कूप लिया',
  'process.v1.seal.title': 'सील लगाएँ',
  'process.v1.seal.mix': 'मिलाएँ, **निशान तक** भरें, बंद करें',
  'process.v1.seal.hint': 'सील स्कैन करें',
  'process.v1.seal.scanned': 'सील {code} स्कैन हुई',
  'process.v1.seal.bad': 'ख़राब',
  'process.v1.seal.from': 'बैच …{code} · {count} बोरी से',
  'process.v1.seal.save': 'नमूना पक्का करें',
  'process.v1.seal.done': 'नमूना पक्का हुआ',
  'process.v1.seal.doneLine': 'सील {code} · लैब भेजें',
  'process.v1.inv.list': 'जाँचने वाले रन',
  'process.v1.inv.none': 'कोई रन जाँचने को नहीं',
  'process.v1.inv.title': 'रन जाँचें',
  'process.v1.inv.held': 'रुका',
  'process.v1.inv.notHeld': 'रुका नहीं',
  'process.v1.inv.less': '{kg} किलो कम · सीमा {pct}',
  'process.v1.inv.more': '{kg} किलो ज़्यादा · सीमा {pct}',
  'process.v1.inv.reweigh': '1. शक वाली बोरी तौलें',
  'process.v1.inv.missed': '2. छूटी बोरी: टैग, तौल',
  'process.v1.inv.noScan': '3. बिना स्कैन: टिन से टैग',
  'process.v1.inv.nextCause': 'आगे: कारण',
  'process.v1.inv.own': 'यह रन आपका था: दूसरा सुपरवाइज़र जाँचे।',
  'process.v1.inv.recorded': '{count} सुधार लिखे',
  'process.v1.inv.unknown': 'एक बोरी का वज़न अभी फ़ोन पर नहीं: सूची अपडेट करें, फिर जाँचें',
  'process.v1.inv.pouch': '4. पाउच की गिनती गलत लिखी',
  'process.v1.inv.pouchTitle': 'पाउच की गिनती ठीक करें',
  'process.v1.inv.pouchNow': 'अभी: {count} पाउच',
  'process.v1.inv.pouchSaved': '{count} पाउच पर ठीक की',
  'process.v1.inv.pouchGood': 'अच्छे पाउच',
  'process.v1.inv.pouchSpoiled': 'खराब लेबल',
  'process.v1.inv.pouchDestroyed': 'नष्ट किए लेबल',
  'process.v1.inv.pouchMax': 'डाले गए माल से ज़्यादा से ज़्यादा {max} पाउच बनते हैं',
  'process.v1.inv.pouchOver': '{max} से ज़्यादा: फिर गिनें',
  'process.v1.inv.pouchWait': 'गिने हुए पाउच लिखें',
  'process.v1.inv.pouchSave': 'गिनती सेव करें',
  'process.v1.inv.pouchLotOpen': 'पैक लॉट बंद नहीं हुआ: अभी पाउच की गिनती ठीक नहीं कर सकते',
  'process.v1.rew.title': 'दोबारा तौलें',
  'process.v1.rew.missed': 'छूटी बोरी',
  'process.v1.rew.noScan': 'बिना स्कैन बोरी',
  'process.v1.rew.scanSack': 'बोरी स्कैन करें',
  'process.v1.rew.scanTin': 'टिन वाला टैग',
  'process.v1.rew.newTag': 'रोल का नया टैग',
  'process.v1.rew.new': 'नया वज़न · बारदाना समेत',
  'process.v1.rew.which': 'कौन सा माल?',
  'process.v1.cause.title': 'कारण चुनें',
  'process.v1.cause.now': 'कम {was} → {now} किलो',
  'process.v1.cause.WEIGHT': 'वज़न, लिखना',
  'process.v1.cause.MACHINE': 'मशीन, नमी',
  'process.v1.cause.MIXING': 'दूसरा माल',
  'process.v1.cause.UNKNOWN': 'पता नहीं',
  'process.v1.cause.which': 'कौन सी?',
  'process.v1.cause.UNWEIGHED_SACK': 'छूटी बोरी',
  'process.v1.cause.SCALE_ERROR': 'काँटा ग़लत',
  'process.v1.cause.TYPING_ERROR': 'लिखना ग़लत',
  'process.v1.cause.BAG_IN_WITHOUT_SCAN': 'बिना स्कैन',
  'process.v1.cause.HIGH_MOISTURE': 'नमी',
  'process.v1.cause.MACHINE_FAULT': 'मशीन ख़राब',
  'process.v1.cause.weighMore': 'और तौलें',
  'process.v1.cause.fromTin': 'टिन से टैग',
  'process.v1.cause.recheck': 'दोबारा जाँचें',
  'process.v1.cause.wait': 'कारण चुनें',
  'process.v1.cause.sent': 'दोबारा जाँच को भेजा',
  'process.v1.cause.accept': 'कमी मानें',
  'process.v1.cause.noAccept':
    'यह कमी यहाँ नहीं मानी जा सकती (ज़्यादा निकला या दूसरा माल): बोरियाँ सुधारें, या दफ़्तर फ़ैसला करे',
}
